var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0965 2.91123C12.781 2.59572 12.2714 2.59572 11.9558 2.91123L7.99984 6.85915L4.04383 2.90314C3.72832 2.58763 3.21865 2.58763 2.90314 2.90314C2.58763 3.21865 2.58763 3.72832 2.90314 4.04383L6.85915 7.99984L2.90314 11.9558C2.58763 12.2714 2.58763 12.781 2.90314 13.0965C3.21865 13.412 3.72832 13.412 4.04383 13.0965L7.99984 9.14053L11.9558 13.0965C12.2714 13.412 12.781 13.412 13.0965 13.0965C13.412 12.781 13.412 12.2714 13.0965 11.9558L9.14053 7.99984L13.0965 4.04383C13.404 3.73641 13.404 3.21865 13.0965 2.91123Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsX);
export default __webpack_public_path__ + "static/media/IconsX.7affad1d3ce5906eea073b6179b9a6c4.svg";
export { ForwardRef as ReactComponent };